// แปลงวันจาก Datepicker (Date หรือ "YYYY-MM-DD") เป็นต้นวัน/ปลายวันตามเวลาเครื่องผู้ใช้
// ส่งเป็น ISO ให้ Strapi — ใช้กับ filter ช่วงเวลาของทุกหน้า จะได้นับวันสุดท้ายรวมทั้งวัน
export function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.toISOString();
}

export function endOfDay(d) {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.toISOString();
}
